import r, { OPTIONS as z } from "../../managers/braze-instance.js";
import ro from "../../util/browser-detector.js";
import {
  clickElement as Et,
  supportsPassive as Tt,
} from "../../util/dom-utils.js";
import { KeyCodes as ie } from "../../util/key-codes.js";
import u from "../../managers/subscription-manager.js";
import { isIFrame as At } from "../utils/in-app-message-utils.js";
export default class InAppMessage {
  constructor(
    t,
    s,
    i,
    h,
    e,
    E,
    n,
    T,
    o,
    r,
    l,
    a,
    A,
    I,
    c,
    O,
    L,
    _,
    m,
    N,
    R,
    S,
    M,
    D,
    C,
    d,
    U,
    b,
    P,
    p,
    f,
    G,
  ) {
    (this.message = t),
      (this.messageAlignment = s),
      (this.slideFrom = i),
      (this.extras = h),
      (this.triggerId = e),
      (this.clickAction = E),
      (this.uri = n),
      (this.openTarget = T),
      (this.dismissType = o),
      (this.duration = r),
      (this.icon = l),
      (this.imageUrl = a),
      (this.imageStyle = A),
      (this.iconColor = I),
      (this.iconBackgroundColor = c),
      (this.backgroundColor = O),
      (this.textColor = L),
      (this.closeButtonColor = _),
      (this.animateIn = m),
      (this.animateOut = N),
      (this.header = R),
      (this.headerAlignment = S),
      (this.headerTextColor = M),
      (this.frameColor = D),
      (this.buttons = C),
      (this.cropType = d),
      (this.orientation = U),
      (this.htmlId = b),
      (this.css = P),
      (this.messageExtras = p),
      (this.language = f),
      (this.altImageText = G),
      (this.message = t),
      (this.messageAlignment = s || InAppMessage.TextAlignment.CENTER),
      (this.duration = r || 5e3),
      (this.slideFrom = i || InAppMessage.SlideFrom.BOTTOM),
      (this.extras = h || {}),
      (this.triggerId = e),
      (this.clickAction = E || InAppMessage.ClickAction.NONE),
      (this.uri = n),
      (this.openTarget = T || InAppMessage.OpenTarget.NONE),
      (this.dismissType = o || InAppMessage.DismissType.AUTO_DISMISS),
      (this.icon = l),
      (this.imageUrl = a),
      (this.imageStyle = A || InAppMessage.ImageStyle.TOP),
      (this.iconColor = I || InAppMessage.th.ih),
      (this.iconBackgroundColor = c || InAppMessage.th.sh),
      (this.backgroundColor = O || InAppMessage.th.ih),
      (this.textColor = L || InAppMessage.th.hh),
      (this.closeButtonColor = _ || InAppMessage.th.eh),
      (this.animateIn = m),
      null == this.animateIn && (this.animateIn = !0),
      (this.animateOut = N),
      null == this.animateOut && (this.animateOut = !0),
      (this.header = R),
      (this.headerAlignment = S || InAppMessage.TextAlignment.CENTER),
      (this.headerTextColor = M || InAppMessage.th.hh),
      (this.frameColor = D || InAppMessage.th.Eh),
      (this.buttons = C || []),
      (this.cropType = d || InAppMessage.CropType.FIT_CENTER),
      (this.orientation = U),
      (this.htmlId = b),
      (this.css = P),
      (this.isControl = !1),
      (this.messageExtras = p),
      (this.language = f),
      (this.altImageText = G),
      (this.nh = !1),
      (this.Ht = !1),
      (this.So = !1),
      (this.Th = !1),
      (this.yo = null),
      (this.wo = null),
      (this.ti = new u()),
      (this.oh = new u()),
      (this.zo = InAppMessage.TextAlignment.CENTER);
  }
  subscribeToClickedEvent(t) {
    return this.ti.Dt(t);
  }
  subscribeToDismissedEvent(t) {
    return this.oh.Dt(t);
  }
  removeSubscription(t) {
    this.ti.removeSubscription(t), this.oh.removeSubscription(t);
  }
  removeAllSubscriptions() {
    this.ti.removeAllSubscriptions(), this.oh.removeAllSubscriptions();
  }
  closeMessage() {
    this.ll(this.yo);
  }
  vo() {
    return !0;
  }
  Po() {
    return this.vo();
  }
  jo() {
    return null != this.htmlId && this.htmlId.length > 4;
  }
  lo() {
    return this.jo() && null != this.css && this.css.length > 0;
  }
  do() {
    if (this.jo() && this.lo()) return this.htmlId + "-css";
  }
  Yt() {
    return !this.Ht && ((this.Ht = !0), !0);
  }
  Ur() {
    return this.Ht;
  }
  $t(t) {
    return !this.So && ((this.So = !0), this.ti.X(), !0);
  }
  Pt() {
    return !this.Th && ((this.Th = !0), this.oh.X(), !0);
  }
  hide(t) {
    if (t && t.parentNode) {
      let s = t.closest(".ab-iam-root");
      if ((null == s && (s = t), this.vo() && null != s.parentNode)) {
        const t = s.parentNode.classList;
        t && t.contains(InAppMessage.rh) && t.remove(InAppMessage.rh),
          document.body.removeEventListener("touchmove", InAppMessage.lh);
      }
      s.className = s.className.replace(InAppMessage.uh, InAppMessage.ah);
    }
    return this.animateOut || !1;
  }
  ll(t, s) {
    if (null == t) return;
    let i;
    (this.yo = null),
      (i =
        -1 === t.className.indexOf("ab-in-app-message")
          ? t.getElementsByClassName("ab-in-app-message")[0]
          : t);
    let h = !1;
    i && (h = this.hide(i));
    const e = document.body;
    let E;
    null != e && (E = e.scrollTop);
    const n = () => {
      if (t && t.parentNode) {
        let s = t.closest(".ab-iam-root");
        null == s && (s = t), s.parentNode && s.parentNode.removeChild(s);
      }
      const i = this.do();
      if (null != i) {
        const t = document.getElementById(i);
        t && t.parentNode && t.parentNode.removeChild(t);
      }
      null != e && "Safari" === ro.browser && (e.scrollTop = E),
        s ? s() : this.Pt();
    };
    h ? setTimeout(n, InAppMessage.cr) : n(), this.wo && this.wo.focus();
  }
  To() {
    return document.createTextNode(this.message || "");
  }
  Lo(t) {
    t.setAttribute("alt", this.altImageText || "");
  }
  static lh(t) {
    if (t.targetTouches && t.targetTouches.length > 1) return;
    const s = t.target;
    (s &&
      s.classList &&
      s.classList.contains("ab-message-text") &&
      s.scrollHeight > s.clientHeight) ||
      (document.querySelector(`.${InAppMessage.rh}`) &&
        t.cancelable &&
        t.preventDefault());
  }
  Ah(t) {
    const s = t.parentNode;
    this.vo() &&
      null != s &&
      this.orientation !== InAppMessage.Orientation.LANDSCAPE &&
      (null != s.classList && s.classList.add(InAppMessage.rh),
      document.body.addEventListener(
        "touchmove",
        InAppMessage.lh,
        !!Tt() && { passive: !1 },
      )),
      (t.className += " " + InAppMessage.uh);
  }
  static Ih(t) {
    if (
      t.keyCode === ie.Oh &&
      !r.ee(z.Lh) &&
      document.querySelectorAll(".ab-modal-interactions").length > 0
    ) {
      const t = document.getElementsByClassName("ab-html-message");
      let s = !1;
      for (const i of t) {
        let t = null;
        At(i) &&
          i.contentWindow &&
          (t = i.contentWindow.document.getElementsByClassName(
            "ab-programmatic-close-button",
          )[0]),
          null != t && (Et(t), (s = !0));
      }
      if (!s) {
        const t = document.querySelectorAll(
          ".ab-modal-interactions > .ab-close-button",
        )[0];
        null != t && Et(t);
      }
    }
  }
  _h() {
    this.nh ||
      r.ee(z.Lh) ||
      (document.addEventListener("keydown", InAppMessage.Ih, !1),
      r.mh(() => {
        document.removeEventListener("keydown", InAppMessage.Ih);
      }),
      (this.nh = !0));
  }
  bt(t) {
    const s = {};
    return t
      ? ((s[InAppMessage.hs.Vr] = this.message),
        (s[InAppMessage.hs.Wr] = this.messageAlignment),
        (s[InAppMessage.hs.Nh] = this.slideFrom),
        (s[InAppMessage.hs.bs] = this.extras),
        (s[InAppMessage.hs.Yr] = this.triggerId),
        (s[InAppMessage.hs.Zr] = this.clickAction),
        (s[InAppMessage.hs.URI] = this.uri),
        (s[InAppMessage.hs.ra] = this.openTarget),
        (s[InAppMessage.hs.sa] = this.dismissType),
        (s[InAppMessage.hs.ta] = this.duration),
        (s[InAppMessage.hs.ia] = this.icon),
        (s[InAppMessage.hs.ds] = this.imageUrl),
        (s[InAppMessage.hs.oa] = this.imageStyle),
        (s[InAppMessage.hs.pa] = this.iconColor),
        (s[InAppMessage.hs.ma] = this.iconBackgroundColor),
        (s[InAppMessage.hs.na] = this.backgroundColor),
        (s[InAppMessage.hs.ua] = this.textColor),
        (s[InAppMessage.hs.ca] = this.closeButtonColor),
        (s[InAppMessage.hs.fa] = this.animateIn),
        (s[InAppMessage.hs.da] = this.animateOut),
        (s[InAppMessage.hs.la] = this.header),
        (s[InAppMessage.hs.ga] = this.headerAlignment),
        (s[InAppMessage.hs.ja] = this.headerTextColor),
        (s[InAppMessage.hs.xa] = this.frameColor),
        (s[InAppMessage.hs.za] = this.buttons),
        (s[InAppMessage.hs.ha] = this.cropType),
        (s[InAppMessage.hs.va] = this.orientation),
        (s[InAppMessage.hs.wa] = this.htmlId),
        (s[InAppMessage.hs.CSS] = this.css),
        (s[InAppMessage.hs.ss] = t),
        (s[InAppMessage.hs.ya] = this.messageExtras),
        (s[InAppMessage.hs.LANGUAGE] = this.language),
        (s[InAppMessage.hs.qs] = this.altImageText),
        s)
      : s;
  }
}
(InAppMessage.th = {
  hh: 4281545523,
  ih: 4294967295,
  sh: 4278219733,
  Rh: 4293914607,
  Sh: 4283782485,
  Eh: 3224580915,
  eh: 4288387995,
}),
  (InAppMessage.xo = {
    Mh: "hd",
    ko: "ias",
    Dh: "of",
    Ch: "do",
    dh: "umt",
    Uh: "tf",
    bh: "te",
  }),
  (InAppMessage.SlideFrom = { TOP: "TOP", BOTTOM: "BOTTOM" }),
  (InAppMessage.ClickAction = { URI: "URI", NONE: "NONE" }),
  (InAppMessage.DismissType = {
    AUTO_DISMISS: "AUTO_DISMISS",
    MANUAL: "SWIPE",
  }),
  (InAppMessage.OpenTarget = { NONE: "NONE", BLANK: "BLANK" }),
  (InAppMessage.ImageStyle = { TOP: "TOP", GRAPHIC: "GRAPHIC" }),
  (InAppMessage.Orientation = { PORTRAIT: "PORTRAIT", LANDSCAPE: "LANDSCAPE" }),
  (InAppMessage.TextAlignment = {
    START: "START",
    CENTER: "CENTER",
    END: "END",
  }),
  (InAppMessage.CropType = {
    CENTER_CROP: "CENTER_CROP",
    FIT_CENTER: "FIT_CENTER",
  }),
  (InAppMessage.ho = {
    Kr: "SLIDEUP",
    Jr: "MODAL",
    Io: "MODAL_STYLED",
    Or: "FULL",
    Hr: "WEB_HTML",
    bo: "HTML",
    Jo: "HTML_FULL",
  }),
  (InAppMessage.cr = 500),
  (InAppMessage.Ph = 200),
  (InAppMessage.uh = "ab-show"),
  (InAppMessage.ah = "ab-hide"),
  (InAppMessage.rh = "ab-pause-scrolling"),
  (InAppMessage.hs = {
    Vr: "m",
    Wr: "ma",
    Nh: "sf",
    bs: "e",
    Yr: "ti",
    Zr: "ca",
    URI: "u",
    ra: "oa",
    sa: "dt",
    ta: "d",
    ia: "i",
    ds: "iu",
    oa: "is",
    pa: "ic",
    ma: "ibc",
    na: "bc",
    ua: "tc",
    ca: "cbc",
    fa: "ai",
    da: "ao",
    la: "h",
    ga: "ha",
    ja: "htc",
    xa: "fc",
    za: "b",
    ha: "ct",
    va: "o",
    wa: "hi",
    CSS: "css",
    ss: "type",
    Ho: "messageFields",
    ya: "me",
    LANGUAGE: "l",
    qs: "ia",
  });
